import { Plane, Package, CheckCircle } from "lucide-react";

const UsaDeliveryDuties = () => {
  return (
    <div className="pt-24 pb-16" data-testid="usa-delivery-duties-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="label-style mb-2">USA Shipping</p>
          <h1 
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
          >
            USA and Delivery Duties
          </h1>
          <p className="text-muted-foreground max-w-xl mx-auto">
            New Rules for shipping to the USA
          </p>
        </div>

        {/* Main Content */}
        <div className="space-y-8">
          {/* New Rules Section */}
          <div className="bg-white border border-border rounded-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
                <Plane className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 
                  className="font-bold text-xl mb-4"
                  style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
                >
                  New Rules for shipping to the USA
                </h2>
                <p className="text-muted-foreground mb-4">
                  From the 29th August an executive order came into force, from now on there is no general duty-free limit for shipments to the USA. The previous $800 de minimis allowance was removed so that all shipments into the USA must have PRE-PAID customs duty.
                </p>
              </div>
            </div>
          </div>

          {/* Our Solution */}
          <div className="bg-white border border-border rounded-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center shrink-0">
                <CheckCircle className="h-6 w-6 text-green-600" />
              </div>
              <div>
                <h2 
                  className="font-bold text-xl mb-4"
                  style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
                >
                  Our Solution
                </h2>
                <p className="text-muted-foreground mb-4">
                  To remedy this we have decided to incorporate this into the shipping costs, by selecting USPS for delivery we can collect and pay the customs duty directly to US authorities thereby making it a smooth passage for the packages and they should sail through customs without unnecessary delays.
                </p>
                <p className="text-muted-foreground">
                  We look forward to getting started for all our US based customers!
                </p>
              </div>
            </div>
          </div>

          {/* Sign Off */}
          <div className="bg-secondary/30 rounded-lg p-6 md:p-8 text-center">
            <p className="text-muted-foreground mb-2">Thanks again,</p>
            <p 
              className="font-bold text-lg"
              style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
            >
              Mini Stripes UK
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsaDeliveryDuties;
